export const environment = {
  production: false,
  api_url: 'https://code-staging-cms.on.dev-craft.tech/api/admin/',
  new_admin_url: 'https://code-staging-cms-vue.on.dev-craft.tech',
  stripe_dashboard_test_mode: true
};



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/environments/environment.ts